<template>
  <div>
    <div class="row">
      <div class="col">
        <div class="indent">
          <strong>
            <a @click="showViewModal = true" v-if="item.description">
              {{name}}
            </a>
            <span v-else>{{name}}</span>
          </strong>
          <strong class="subheader"> ({{item.current}}/{{item.maximum}})</strong>
        </div>
      </div>

      <!-- checkboxes -->
      <div class="col-flex text-center" v-if="item.type === 'checkboxes' && item.maximum && item.maximum > 0">
        <span class="cboxes" v-for="n in item.maximum" :key="n">
          <i v-if="cboxArray.includes(n)" class="fa fa-fw fa-check-square" aria-hidden="true" @click="upDown(-1)"></i>
          <i v-else class="fa fa-fw fa-square-o c5" aria-hidden="true" @click="upDown(1)"></i>
        </span>
      </div>

      <!-- number -->
      <div class="col-2 text-center" v-else>
        <under-input v-model.number="item.current" min="0" :max="item.maximum" hideLabel="true"></under-input>
      </div>

      <div class="col-flex" v-if="canEdit">
        <a :id="`${section}-${item._id}`" @click="$emit('setId')" class="cogs125 modal-toggle">
          <i class="fa fa-cog"></i>
        </a>
      </div>
    </div>

    <ez-modal v-if="showViewModal" @close="showViewModal = false" size="m-medium">
      <display :item="item"></display>
    </ez-modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import modal from "@/mixins/vue-ez-modal";
import Display from "./_Display.vue";
import UnderInput from "../shared/_UnderInput.vue";

export default {
  name: "sheet-trackables-trackable",
  mixins: [modal],
  components: {
    Display,
    UnderInput
  },
  props: ["section", "item"],
  data() {
    return {
      showViewModal: false
    };
  },
  computed: {
    ...mapGetters({ canEdit: "characters/canEdit" }),
    name() {
      return this.item.name || "Trackable";
    },
    cboxArray() {
      let arr = [];
      if (
        this.item.current &&
        this.item.current > 0 &&
        this.item.type === "checkboxes"
      ) {
        for (let i = 0; i < this.item.current; i++) {
          arr.push(i + 1);
        }
      }
      return arr;
    }
  },
  methods: {
    ...mapActions("characters", ["autoSave"]),
    upDown(n) {
      if (this.canEdit) {
        this.item.current += n;
        this.autoSave();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/_global";

input {
  margin: 0;
}
.cboxes {
  line-height: 1;
  font-size: 1.1em;
  cursor: pointer;
}
</style>
